import Vue from "vue";
import VueI18n from "vue-i18n";
import store from "../store/store";

Vue.use(VueI18n);

let locale = "ar";

export default new VueI18n({
    locale: locale,
    messages: {
        ar: {
            All: "الكل",
            Back: "رجوع",
            Language: "اللغة الإفتراضية",
            EN: "English",
            AR: "العربية",
            Currency: "العملة",
            AppTitle: "مسلم",
            AddtoCart: "إضافة للسلة",
            BuyItNow: "شراء فوري",
            HowMany: "حدد الكمية",
            DoneOrdering: "إلي السلة",
            ItemVariants: "يوجد {0} مقاسات من هذا الصنف",
            EGP: "ج. م.",
            Choose: "إختر",
            ChooseWidget: "إختر الويدجت من القائمة",
            ChooseSize: "إختر الحجم",
            bot2: "قم بمراجعة طلبك وإضافة أي ملاحظات علي الأصناف التي طلبتها",
            Title: "الإسم",
            Qty: "الكمية",
            Size: "الحجم",
            Price: "السعر",
            Total: "إجمالي",
            Note: "ملاحظة",
            Next: "التالي",
            Previous: "السابق",
            user1: "قمت بمراجعة وتأكيد طلبي",
            bot3: "قم بإدخال بيانات التوصيل",
            Name: "الإسم",
            Phone: "الهاتف",
            UserCode: "كود المستخدم",
            Phone2: "هاتف إضافي (إختياري)",
            Zone: "توصيل إلي",
            PickZone: "إختر منطقة",
            AdjustZone: "تغيير المنطقة",
            Address: "العنوان",
            bot4: "قبل إنهاء طلبك وارساله للمطعم ألقي نظرة أخيرة عليه",
            TotalQuantity: "الكمية الكلية",
            TotalPrice: "السعر الكلي",
            DeliveryPrice: "التوصيل",
            Subtotal: "الإجمالي",
            Confirmation: "تأكيد الطلب",
            Cancel: "إلغاء",
            items: "صنف (أصناف)",
            MakeOrder: "طلب جديد",
            Password: "كلمة السر:",
            Login: "تسجيل الدخول",
            Guest: "المتابعة كضيف",
            Dashboard: "لوحة التحكم",
            Branches: "الفروع",
            Orders: "الطلبات",
            Products: "المنتجات",
            Categories: "المجموعات",
            Subcategories: "مجموعات فرعية",
            Subcategory: "مجموعة فرعية",
            Users: "المستخدمين",
            Logout: "خروج",
            PendingOrders: "طلبات قيد التوصيل",
            ConfirmedOrders: "طلبات تم تأكيدها",
            CompletedOrders: "الطلبات المكتملة",
            CancelledOrders: "الطلبات الملغية",
            TotalOrders: "عدد الطلبات الكلي",
            Images: "صور",
            Add: "إضافة",
            View: "عرض",
            Edit: "تعديل",
            New: "جديد",
            Delete: "حذف",
            NA: "لا توجد بيانات للعرض",
            Branch: "فرع",
            BranchPhone: "هاتف الفرع",
            BranchAddressAR: "عنوان الفرع بالعربية",
            BranchAddressEN: "عنوان الفرع بالإنجليزية",
            Pending: "قيد الإنتظار",
            Confirmed: "تم التأكيد",
            OnTheWay: "في الطريق إليك",
            Completed: "تم التسليم",
            Cancelled: "ملغي",
            ViewAll: "عرض الكل",
            BranchOrders: "طلبات الفرع",
            ProductData: "بيانات الصنف",
            ProductVariants: "أحجام الصنف",
            ProductImages: "صور الصنف",
            Submit: "حفظ",
            Uplaod: "رفع صور",
            Update: "تحديث",
            NewProduct: "إضافة منتج جديد",
            EditProduct: "تعديل منتج",
            EditImage: "تعديل الصورة",
            Category: "مجموعة",
            ChooseCategory: "إختر المجموعة",
            ChooseSubcategory: "إختر المجموعة الفرعية",
            ChooseBrand: "إختر الماركة",
            FillForm: "إملأ الحقول واضغط حفظ أدناه",
            description: "الوصف (إختياري)",
            bot5: "قم بتسجيل الدخول أو متابعة طلبك كضيف",
            bot6: "سيقوم فريقنا بالتواصل معك عند تأكيد طلبك",
            AddressBook: "قم بالإختيار من دليل عناوينك",
            MyInfo: "بياناتي",
            MyOrders: "طلباتي",
            MyAddressBook: "دفتر عناويني",
            NewOrder: "طلب جديد",
            Update: "تحديث",
            Name: "الإسم",
            Email: "البريد الإلكتروني",
            Password: "كلمة السر",
            PasswordMsg: "إملأ الحقل لتغيير كلمة السر",
            MyAddresses: "عناويني",
            AddAddress: "إضافة عنوان",
            EditAddress: "تعديل عنوان",
            Cart: "سلة المشتريات",
            AddMore: "إضافة صنف",
            EmptyCart: "تفريغ السلة",
            CartEmpty: "السلة فارغة!",
            BrowseMenu: "تصفح قائمة الطعام",
            Home: "الرئيسية",
            TitleAR: "الإسم بالعربية",
            TitleEN: "الإسم بالإنجليزية",
            Descriptions: "وصف المنتج",
            DescriptionAR: "الوصف بالعربية",
            DescriptionEN: "الوصف بالإنجليزية",
            AdURL: "رابط الإعلان",
            AdGroup: "مجموعة الإعلان",
            Ads: "الإعلانات",
            isAvilable: "متوفر؟",
            Current: "الحالية",
            ToCheckout: "إتمام الطلب",
            Receipt: "الإيصال",
            DeliveryInfo: "بيانات التوصيل",
            OrderPrepared: "طلبك قيد التأكيد",
            Approval: "موافق",
            POS: "طلبات التوصيل",
            ServicesTax: "الخدمات والضرائب",
            invalidProvider:
                "رقم الهاتف يجب أن يبدأ بـ 010 أو 011 أو 012 أو 015",
            invalidLength: "رقم الهاتف يجب أن يكون من 11 خانة فقط",
            ChangeLang: "تغيير اللغة إلي",
            Profile: "الملف الشخصي",
            LoginMsg: "قم بتسجيل الدخول او المتابعة كضيف",
            SignMsg: "مرحبا! قم بالتسجيل او المتابعة كضيف",
            Hello: "مرحبا",
            Signup: "التسجيل",
            Success: "نجاح!",
            QRMSG: "إحفظ الكود لتتبع الطلب رقم",
            Save: "حفظ",
            SaveAll: "حفظ الكل",
            Zones: "المناطق",
            ZonesD: "مناطق التوصيل",
            NameAR: "الإسم بالعربية",
            NameEN: "الإسم بالإنجليزية",
            OrdersbyBranches: "الطلبات حسب الفروع",
            Date: "التاريخ",
            Status: "الحالة",
            Action: "تحكم",
            Pending: "إنتظار",
            Confirmed: "تم التأكيد",
            // Completed: "مكتمل",
            Cancelled: "ملغي",
            Update: "تحديث",
            General: "تفاصيل عامة",
            Code: "الرقم المتسلسل",
            CartPrice: "إجمالي السلة",
            ProductQty: "عدد المنتجات",
            Notes: "ملاحظات الطلب",
            NN: "لا توجد ملاحظة",
            Promocodes: "التخفيضات",
            Edit: "تعديل",
            StreetNameNum: "العنوان بالتفصيل",
            BuildingNum: "رقم المبني",
            FloorNum: "رقم الطابق",
            FlatNum: "رقم الشقة",
            Landmark: "معلم بارز",
            building: "عمارة",
            Code: "الكود",
            Starts: "تاريخ البداية",
            Ends: "تاريح النهاية",
            Amount: "القيمة",
            Type: "النوع",
            Fixed: "قيمة ثابتة",
            Precentage: "نسبة مئوية",
            CreatePromocode: "كود جديد",
            editPromocode: "تعديل الكود",
            NewAccount: "إنشاء حساب جديد",
            Register: "إنشاء حساب",
            GuestOrders: "طلباتي كضيف",
            LatestDeals: "آخر العروض",
            Favorites: "المفضلة",
            Uploaded: "تم رفع",
            Reset: "حذف",
            ImgSize: "يجب ألايتجاوز حجم الصورة 1 ميجابايت. أعد رفع الصور",
            LoginError: "رقم الهاتف أو كلمة المرور خطأ حاول مجددا",
            Required: "هذه الخانة لا يمكن أن تترك فارغة",
            NameOOR: "عدد حروف الإسم يجب أن تكون أكثر من حرفين",
            PhoneOOR: "يجب أن يكون رقم الهاتف مكون من 11 رقم",
            PhoneMS: "رقم الهاتف يجب أن يبدأ بـ010 أو 011 أو 012 أو 015",
            PhoneUNQ: "هذا الرقم مسجل مسبقا",
            PhoneIV:
                "يجب أن يتكون رقم الهاتف من 11 خانة للهاتف أو 7 إلي 8 خانات للخط الأرضي مع الكود",
            PhoneIV2: "يجب أن يتكون رقم الهاتف من 9 خانة مع الكود",
            PasswordOOR: "كلمة المرور يجب أن تتكون من 6 خانات علي الأقل",
            PasswordNS: "يجب أن لا تحتوي كلمة السر علي مسافات",
            Success: "تمت العملية بنجاح",
            AddCategory: "إضافة مجموعة",
            AddProduct: "إنشاء منتج جديد",
            ShowProducts: "المنتجات",
            SetZone: "حدد أقرب منطقة توصيل للطلبات",
            SetDZone: "حدد المنطقة",
            Confirm: "تأكيد",
            NAZ: "لا توجد طلبات بدون مناطق توصيل",
            ChangeStatus: "تغيير الحالة",
            Change: "تغيير",
            BranchesStats: "إحصائيات الفروع",
            All: "الكل",
            Filter: "فلتر",
            Clear: "حذف",
            SearchByCode: "إبحث بالكود التعريفي",
            SearchByUserCode: "إبحث بالكود المستخدم",
            SuccessOrder: "طلبك قيد التحضير",
            Optional: "إختياري",
            TypeNotes: "أكتب ملاحظاتك",
            SaveAsImg: "إحفظ الكود",
            BrowseMenu: "تصفح الأصناف",
            RedirectWarning: "تنبيه لا يمكن الرجوع لهذه الصفحة بعد إغلاقها",
            inputAddress: "إضافة عنوان",
            NAA: "لا توجد عناوين للعرض قم بإضافة عنوان",
            ZoneP: "المنطقة",
            Search: "بحث",
            SearchProducts: "بحث المنتجات",
            SearchResults: "نتائج البحث",
            OrderNum: "كود الطلب",
            Product: "منتج",
            Image: "الصورة",
            Ingredients: "مكونات من إختيارك",
            AddIngredients: "قم بإضافة المكونات",
            Clients: "العملاء",
            History: "تاريخ الطلبات",
            Joined: "تاريخ التسجيل",
            NotesClient: "ملاحظات علي العميل",
            Remove: "حذف",
            Extras: "إضافات",
            GuestMsg: "لم تسجل بعد؟",
            Staff: "الموظفين",
            CreateStaff: "إضافة موظف",
            UserRemove: "هل أنت متأكد من حذف هذا الموظف؟",
            ProductNA: "الصنف غير متوفر، بالرجاء حذفه",
            Description: "الوصف",
            NDA: "منطقة غير نشطة حاليا",
            AddressToBook: "سيتم إضافة العنوان المدخل إلي دفتر عناوينك",
            NITM: "بدون",
            WithExtra: "مع إضافة",
            Affrim: "هل أنت متأكد؟",
            InsertPhone: "أدخل رقم الهاتف",
            InsertPassword: "أنت عميل مسجل",
            Continue: "متابعة",
            OR: "أو",
            Grid: "بطاقات",
            List: "قائمة",
            MyOrders: "طلباتي",
            Notifications: "الإشعارات",
            CancelAddress: "الإختيار من عناويني",
            OrderSuccessNotification:
                "الطلب رقم {code} قيدالتحضير. سيتم إرسال إشعار آخر عند تغير الحالة.",
            CompleteMeal: "أكمل وجبتك",
            Saving: "تحميل...",
            MassUpload: "تحميل المنتجات",
            UploadProducts: "تحميل المنتجات",
            UploadAll: "تحميل كل المنتجات",
            DropFiles: "قم بإلقاء صور المنتجات هنا",
            SelectFiles: "إضغط لإختيار الصور",
            UploadProduct: "تحميل المنتج",
            AddProducts: "تحميل أكثر من منتج",
            isPrimary: "مجموعة رئيسية ؟",
            Deals: "العروض",
            NameRequired: "قم بإدخال الإسم",
            PhoneRequired: "قم بإدخال رقم الهاتف",
            AddressRequired: "الرجاء إدخال عنوان ومنطقة توصيل",
            Category: "مجموعة",
            VariantsError: "فضلا فم بإضافة حجم واحد علي الأقل",
            TodaysOrders: "طلبات اليوم",
            From: "من تاريخ",
            To: "إلي تاريخ",
            OK: "موافق",
            OrderReceivedPlain: "نشكرك.. تم إستلام الطلب رقم",
            OrderReceived: "نشكرك.. تم إستلام الطلب رقم {0}",
            OrderPending: "وجاري تأكيد الطلب",
            OrderConfirmed: "تم تأكيد الطلب رقم {0} وجاري التحضير",
            OrderOnTheWay: "الطلب {0} في الطريق إليك",
            OrderCompleted: "تم توصيل الطلب رقم {0}",
            ItemsQty: "عدد أصناف الطلب",
            Move: "نقل",
            MoveTo: "نقل إلي",
            AddMore: "إضافة المزيد",
            DeliveryMethod: "نوع الطلب",
            delivery: "توصيل للمنزل (دليڤري)",
            takeaway: "استلام من فرع",
            PickupTime: "توقيت الإستلام",
            FromBranch: "من فرع",
            ChooseBranch: "إختر الفرع",
            BranchRequired: "الرجاء إختيار الفرع لإستلام الطلب",
            SaveWAMessage: "إرسال كود الطلب للمطعم",
            ScreenshootOrder:
                "بالرجاء تصوير الشاشة للإحتفاظ بكود الطلب لتتمكن من تتبعه أو أرسله كرسالة واتساب للمطعم",
            Takeaway: "تيك أواي",
            Delivery: "توصيل",
            TakeawayTime: "زمن الإستلام",
            Settings: "إعدادات",
            GeneralSettings: "إعدادات عامة",
            RestrauntTitleAR: "إسم المتجر بالعربية",
            RestrauntTitleEN: "إسم المتجر بالإنجليزية",
            RestrauntPhone: "هاتف المتجر",
            RestrauntWAPhone: "رقم الواتساب",
            Logo: "الشعار",
            ImportantLinks: "روابط مهمة",
            Website: "الموقع الإلكتروني",
            Facebook: "فيسبوك",
            Twitter: "تويتر",
            Instagram: "إنستغرام",
            Youtube: "يوتيوب",
            WizardWelcome: "مرحبا! لنقم بإعداد مطعمك سويا",
            AdminProfile: "حساب الإدارة",
            HomeSlider: "صور العرض",
            ProuctSetup: "إضافة منتجات",
            Sorry: "عذرا",
            Message404: "المتجر تحت التشييد. بالرجاء الزيارة لاحقا",
            WorkStarts: "من",
            WorkEnds: "إلي",
            WorkDay: "يبدأ العمل",
            AdminName: "إسم صاحب المتجر",
            AdminPhone: "رقم الهاتف",
            AdminPhoneMsg: "سيتم إستخدام هذا الرقم لتسجيل الدخول للوحة التحكم",
            SliderMsg:
                "سيتم عرض هذه الصور في الصفحة الرئيسية. إختر صورة واحدة علي الأقل للمتابعة",
            Upload: "رفع",
            BranchSetup: "فرعك الرئيسي",
            MainBranchDetails:
                "يجب أن يحتوي مطعمك علي الأقل علي فرع واحد ومنطقة توصيل واحدة. الرجاء إدخال تفاصيل فرعك الرئيسي",
            AddZone: "إضافة منطقة توصيل",
            submitBranch: "إضافة الفرع ومناطق التوصيل",
            RestaurantSetup: "مبروك!",
            RestaurantSetupMsg:
                "لقد قمت بإعداد واجهة متجرك بنجاح قم بتسجيل الدخول لإضافة منتجاتك",
            AddProductsP:
                "رجاءا قم بإضافة مجموعة واحدة علي الأقل ليبدأ مطعمك العمل",
            ServiceMsg: "عذرا... نسعد بخدمتكم",
            RestrauntTitle: "إسم المتجر",
            MaxImages: "أقصي عدد للصور 12 صورة",
            SliderImages: "صور السلايدر",
            DragImages: "إضغط أو ضع الصور للرفع",
            SliderOverLimit: " تخطيت عدد الصور المسموح بها. سيتم رفع",
            Allowed: " من الصور المضافة",
            Optional: "إختياري",
            BranchLocationURL: "رابط موقع الفرع علي الخريطة",
            ExtraNotes: "ملاحظات إضافية",
            RepeatOrder: "إعادة طلب",
            RepeatedOrder: "هل تود طلب نفس الطلب بنفس الأصناف مرة أخري؟",
            checkOrder: "تتبع طلبك",
            GetStatus: "تتبع الطلب",
            GetStatusTxt:
                "يبدو أنك غير مسجل! هل تود التسجيل لمتابعة كل طلباتك أو قم بالمتابعة كضيف",
            OrderSettings: "إعدادات الطلبات",
            AddStatus: "إضافة حالة طلب جديدة",
            StatusColor: "لون الحالة",
            DiscountPrice: "سعر الخصم",
            DiscountType: "نوع الخصم",
            DiscountAmount: "قيمة الخصم",
            DiscountOptions: "إضافة الخصم علي خيارات المنتج",
            Dishes: "الأصناف",
            Prices: "أسعار الأحجام",
            PhoneNumber: "رقم الهاتف",
            OrderCode: "كود الطلب",
            Appearance: "العرض",
            Background: "لون الخلفية",
            CardBackground: "لون خلفية الكرت",
            BackgroundColor: "لون خلفية التطبيق",
            PrimaryColor: "اللون الرئيسي",
            SecondaryColor: "اللون الفرعي",
            BorderRadius: "تكوير الحواف",
            CardBorderRadius: "تكوير حواف الكرت",
            SliderHeight: "طول السلايدر",
            DiscountImageAR: "صورة العرض للغة العربية",
            DiscountImageEN: "صورة العرض للغة الإنجليزية",
            PX: "بيكسل",
            UserNotFound: "لا يوجد مستخدم أو طلبات بهذا الرقم",
            PasswordReset: "رجاءا قم بإنشاء كلمة سر جديدة",
            NewPasword: "كلمة السر الجديدة",
            ResetSuccess: "تم تغيير كلمة السر بنجاح، قم بتسجيل الدخول",
            UploadUsers: "إنشاء عملاء",
            Invited: "مدعو",
            Verified: "موثوق",
            SecurePassword: "كلمة سر آمنة",
            VerifyUser: "توثيق المستخدم",
            MassBranches: "رفع من ملف",
            RefreshedPage: "تم تحديث الصفحة",
            InvitedClients: "العملاء المدعويين",
            Invite: "رابط الدعوة",
            ShowMenu: "أطلب الآن",
            Landing: "الرئيسية",
            LandingPage: "صفحة الهبوط",
            NewAd: "إعلان جديد",
            NewAdGroup: "مجموعة إعلانات جديدة",
            VisitAd: "المزيد",
            PackageItems: "أصناف العرض",
            Show: "إظهار؟",
            HomeBackground: "خلفية الصفحة الرئيسية",
            AdsBackgroundColor: "لون خلفية الإعلانات",
            GridOptions: "خيارات عرض الإعلانات",
            GridColumnsIn: "عدد أعمدة العرض علي",
            MobileScreen: "شاشة الموبايل",
            TabletScreen: "شاشة التابلت",
            BigScreen: "الشاشات الأكبر",
            GridGap: "المساحة بين الأعمدة والصفوف (رقم بين 0 - 4)",
            ImageBR: "تكوير أطراف صورة القسم (نسبة مئوية)",
            AdBR: "تكوير أطراف صورة الإعلان (نسبة مئوية)",
            AdModalIH: "طول صورة الإعلان في المودال (بيكسل)",
            AdModalIV: "عرض صورة الإعلان في المودال (بيكسل)",
            TextColor: "لون الخط",
            TitleDetails: "إعدادات العنوان",
            TitleDescription: "إعدادات النص",
            FontSize: "حجم الخط (بيكسل)",
            TextAlign: "موقع النص",
            Center: "المنتصف",
            Left: "اليسار",
            Right: "اليمين",
            Justify: "ملأ السطر",
            FontWeight: "وزن الخط",
            Light: "خفيف",
            Normal: "عادي",
            Medium: "متوسط",
            Bold: "عريض",
            Width: "عرض الصورة",
            BoxShadow: "ظل الصورة",
            ZoneUnavailable: "هذه المنطقة غير متوفرة رجاءا قم بتغييريها",
            EditDeliveryMethod: "تعديل طريقة التوصيل",
            CustomerData: "بيانات العميل",
            NotAdded: "غير محدد",
            ContainerWidth: "عرض مساحة الصورة",
            Height: "الطول",
            ContentWidth: "عرض المحتوي",
            ContentType: "نوع المحتوي",
            RestrauntDeliveryTime: "زمن التسليم للعميل (بالدقائق)",
            Select: "إختيار",
            StockEnabled: "تفعيل المخزون؟",
            Stock: "المخزون",
            LowStockAlert: "تحذير المخزون",
            Restock: "إعادة تعبئة",
            Available: "متوفر",
            Recommended: "مختارات",
            Icon: "الأيقونة",
            SlideShow: "عرض الصور",
            CategoryListView: "مجموعة منتجات (قائمة)",
            CategoryGridView: "مجموعة منتجات (جريد)",
            LayoutContainer: "إضافة محتوي",
            GridType: "شكل الـgrid",
            BoxModel: "المساحات من أطراف الصفحة",
            Side: "تطبيق",
            Horizontal: "أفقيا",
            Vertical: "رأسيا",
            Pixel: "بيكسل",
            NumberOfSections: "عدد الكروت",
            SectionsSpacing: "المساحة بين الكروت",
            LayoutSections: "محتوي الكروت",
            Section: "الكرت",
            VerticalSpacing: "المساحة أعلي وأسفل المجموعة",
            ProductHasOptions: "المنتج يدعم خيارات متعددة",
            PriceSettings: "إعدادات السعر والمخزون",
            AddOption: "إضافة خيار",
            Value: "القيمة",
            Variants: "الخيارات",
            OutOfStock: "هذا المنتج غير متاح.. الكمية نفدت",
            AddedToCart: "تم إضافة المنتج لسلة المشتريات",
            Phones: "تلفونات",
            Covers: "كفرات",
            Accessories: "إكسسورات",
            Earphones: "سماعات",
            Lighting: "إضاءة",
            AdWidget: "إعلان",
            Sort: "ترتيب",
            NoSort: "غير مرتبة",
            PriceASC: "بالسعر من الأقل للأعلي",
            PriceDSC: "بالسعر من الأعلي للأقل",
            FromP: "الحد الأدني",
            ToP: "الحد الأعلي",
            PriceFilter: "فلتر السعر",
            SearchResult: "نتائج البحث",
            SearchByProductBarcode: "البحث باركود المنتج",
            PickProducts: "منتجات المجموعة",
            isAdvertisment: "مجموعة إعلانية",
            ProductSlider: "سلايدر منتجات",
            ChooseOrUpload: "إختيار أو تحميل صورة",
            URLAR: "نص الرابط (عربي)",
            URLEN: "نص الرابط (إنجليزي)",
            CustomizeApp: "صفحة هبوط التطبيق",
            ChooseView: "إختيار طريقة العرض",
            Grid: "جريد",
            List: "قائمة",
            Slider: "سلايدر",
            Ad: "إعلان",
            ShowTitle: "إظهار عنوان المجموعة",
            ShowLink: "إظهار الرابط",
            PickWidget: "إختيار ويدجت",
            ChooseImages: "إختيار الصور",
            Customize: "تعديل",
            ChooseProduct: "إختيار المنتج",
            Tags: "التاغ",
            DisplayedTags: "التاجات المعروضة",
            Social: "روابط سوشال ميديا",
            PaymentMethod: "طريقة الدفع",
            cash: "دفع عند الإستلام",
            card: "دفع إلكتروني",
            FB: "رابط فيسبوك",
            TW: "رابط تويتر",
            IG: "رابط إنستغرام",
            YT: "رابط يوتيوب",
            WA: "رقم الواتساب بدون + أو 0 في البداية (مثال 201234567890)",
            TextWidget: "نص",
            InStock: "في المخزن",
            VerifyProducts: "تأكيد المنتجات",
            Create: "إنشاء",
            SimilarProducts: "منتجات مشابهة",
            AddedToProduct: "إضافة كخيار",
            LeftInStock: "متبقي من المنتج",
            readMore: "جميع الفئات",
            Options: "خيارات المنتج",
            Hide: "إخفاء",
            HideSelected: "إخفاء",
            ReasonToHide: "سبب الإخفاء",
            Barcode: "باركود",
            ShowHidden: "إظهار المنتجات المخفية",
            ShowVisible: "إظار المنتجات المتاحة",
            MenuLimit: "عدد روابط المنيو",
            ContainerHeight: "إرتفاع الويدجت",
            IsTransparent: "خلفية شفافة؟",
            ShadowEnabled: "ظل الكرت",
            ImageShadowEnabled: "ظل الصورة",
            SlidesPerView: "عدد الكروت في الشاشة",
            SpaceBetweenSlides: "المساحة بين الكروت (بيكسل)",
            RelatedProducts: "منتجات ذات صلة",
            Brands: "الماركات",
            Brand: "ماركة",
            AddBrand: "إضافة ماركة",
            MyHome: "الرئيسية",
            MyCart: "سلة المشتريات",
            MyProfile: "صفحتي الشخصية",
            BrowseCategories: "تصفح المنتجات",
            BrowseBrands: "تصفح الماركات",
            Header: "الهيدر",
            Widget: "ويدجت",
            Preveiw: "عرض",
            CardHeight: "إرتفاع الكرت",
            ImageHeight: "إرتفاع الصورة",
            ImgBorderRadius: "تكوير حواف الصورة",
            ItemsLimit: "عدد المنتجات المعروضة",
            ShowCategoryTitle: "إظهار عنوان المجموعة",
            ShowProductInfo: "إظهار بينات المنتج",
            ProductTitle: "إسم المنتج",
            ProductPrice: "سعر المنتج",
            HideBackground: "إخفاء لون خلفية الويدجت",
            ImageBorder: "إطار الصورة",
            PaymentStatus: "حالة الدفع",
            Paid: "تم الدفع",
            Unpaid: "بإنتظار الدفع",
            PaymentInfo: "بيانات الدفع",
            InvoiceURL: "رابط الإيصال",
            PaymentURL: "رابط الدفع",
            Press2Pay: "إضغط هنا",
            PaymentElectronic: "تفعيل الدفع الإلكتروني",
            PaymentCash: "تفعيل الدفع عند الإستلام",
            NoPaymentFound: "الرجاء تفعيل وسيلة دفع واحدة علي الأقل",
            NoDeliveryFound: "الرجاء تفعيل طريقة توصيل واحدة علي الأقل",
            FinalPrice: "الأجمالي الكلي",
            PaymentPermission: "السماح بإعادة توجيهك للدفع",
            MustRegister: "يجب التسجيل كعميل جديد للمواصلة",
            ClientNotes: "تعليقات علي العميل",
            NumOfOrders: "عدد الطلبات",
            AppendOrder: "هل تود إضافة الطلب الحالي علي الطلب السابق كملحق؟",
            AddPhone: "إضافة رقم هاتف",
            SaveUser: "حفظ كعميل جديد",
            GUser: "عميل غير مسجل",
            AddPhoneMessage: "إضافة رقم آخر",
            UpdateUser: "تعديل بيانات العميل",
            AddressManual: "إدخال عنوان",
            ClientOrders: "طلبات العميل السابقة",
            OrderCount: "عدد الطلبات",
            CancelledCount: "عدد الطلبات الملغية",
            FirstOrder: "تاريخ الطلب الأول",
            LastOrder: "تاريخ آخر طلب",
            OrderAvg: "متوسط الطلبات",
            AddNote: "إضافة تعليق",
            Send: "إرسال",
            WidgetAdded: "تم إضافة ويجدجت جديد",
            EnableCallcenter: "تفعيل طلبات التوصيل (الكول سنتر)",
            EnableProductSupervision: "تفعيل الإشراف علي إدخال المنتجات",
            Variants: "متغيرات المنتجات",
            Variant: "المتغير",
            Values: "قيم المتغير",
            NewVariant: "إضافة متغير جديد",
            NewVariantValue: "إضافة قيمة جديدة",
            NoVariants:
                "لا يوجد متغيرات علي النظام. رجاء قم بإضافة متغيرات للمنتجات أولا",
            AllowBarcodeEdit: "السماح بتعديل الباركود عند تعديل المنتجات",
            ShowBarcode: "إظهار حقل الباركود عند إنشاء المنتج",
            AvailableQty: "الكمية المتوفرة",
            DeliveredBy: "قام بالتوصيل",
            ParentOrder: "طلب يحتوي ملحقات",
            ChildOrder: "طلب ملحق علي طلب آخر",
            NeutralOrder: "طلب بدون ملحقات",
            AppendOrders: "إضافة ملحقات",
            AppendedTo: "ملحق علي",
            Navigation: "Navigation",
            Role: "الوظيفة",
            Operator: "مشغل",
            Employee: "موظف",
            Admin: "أدمن",
            CallCenter: "كول سنتر",
            CallCenterManager: "مدير كول سنتر",
            HasMobileApp: "يملك المتجر تطبيق هاتف",
            AppleStore: "(رابط التطبيق) رابط آبل ستور",
            PlayStore: "رابط بلاي ستور (رابط التطبيق)",
            Offers: "التخفيضات",
            CreateOffer: "إنشاء تخفيض جديد",
            Advertisers: "عملاء الإعلانات",
            CreateAdvertiser: "إنشاء عميل إعلانات",
            OfferTypes: "أنواع التخفيضات",
            CreateOfferType: "إنشاء نوع تخفيضات",
            Promocode: "بروموكود",
            PromocodeSearch: "بحث بالبروموكود",
            Advertiser: "المعلن",
            OfferType: "نوع التخفيض",
            IsActive: "مفعل؟",
            DeductFixed: "خصم سعر ثابت",
            DeductPercent: "خصم نسبة مئوية",
            FixedPrice: "سعر ثابت",
            Active: "مفعل",
            InActive: "غير مفعل",
            UnableToRemove: "لا يمكن الحذف لوجود بيانات معتمدة عليه",
            ProductInOtherOffer: "تنبيه! هذا المنتج موجود في تخفيض آخر",
            isPromotional: "مجموعة إعلانية؟",
            CategoryType: "نوع المجموعة",
            Visible: "معروض",
            Invisible: "مخفي",
            Main: "محموعة رئيسية",
            Promotional: "مجموعة إعلانية",
            AttachProducts: "إضافة منتجات",
            AddDescription: "إضافة وصف علي الخيارات",
            VariantImages: "صور الألوان",
            VariantColor: "اللون",
            Saved: "تم الحفظ",
        },
        en: {
            All: "All",
            Back: "Back",
            readMore: "Browse Categories",
            Language: "Change Language",
            EN: "English",
            AR: "العربية",
            Currency: "Currency",
            Home: "Home",
            AppTitle: "Muslim",
            AddtoCart: "Add To Cart",
            BuyItNow: "Buy It Now",
            HowMany: "How Many?",
            DoneOrdering: "To Cart",
            ItemVariants: "This product has {0} sizes",
            EGP: "EGP",
            ChooseSize: "Choose Size",
            ChooseWidget: "Choose Widget from dropdown",
            bot2: "Kindly review your items and add notes to any of them if you wish",
            Title: "Item",
            Qty: "Qty",
            Total: "Total",
            Price: "Price",
            Size: "Size",
            Note: "Note",
            Next: "Next",
            Previous: "Previous",
            user1: "I have reviewed and confirmed my order",
            bot3: "Let's get your delivery information",
            Name: "Name",
            Phone: "Phone",
            UserCode: "User Code",
            Phone2: "Additional Phone Number",
            Zone: "Which of the following zones is closest to you?",
            Address: "Delivery Address",
            bot4: "Before we pass order for admin confirmation here's a summary of your order",
            TotalQuantity: "Total Quantity",
            TotalPrice: "Total Price",
            DeliveryPrice: "Delivery Price",
            Subtotal: "Subtotal",
            Confirmation: "Confirmation",
            Cancel: "Cancel",
            items: "Item(s)",
            MakeOrder: "Make New Order",
            Password: "Password:",
            Login: "Login",
            Guest: "Continue as Guest",
            Dashboard: "Dashboard",
            Branches: "Branches",
            Orders: "Orders",
            Products: "Products",
            Categories: "Categories",
            Subcategories: "Subcategories",
            Subcategory: "Subcategory",
            Users: "Users",
            Logout: "Logout",
            PendingOrders: "Pending Orders",
            ConfirmedOrders: "Confirmed Orders",
            CompletedOrders: "Completed Orders",
            CancelledOrders: "Cancelled Orders",
            TotalOrders: "Total Orders",
            Images: "Images",
            Add: "Add",
            View: "View",
            Edit: "Edit",
            New: "New",
            Delete: "Delete",
            NA: "No data available to show",
            Branch: "Branch",
            BranchPhone: "Branch Phone",
            BranchAddressAR: "Branch Address (ar)",
            BranchAddressEN: "Branch Address (en)",
            Pending: "Pending",
            Confirmed: "Confirmed",
            Completed: "Delivered",
            OnTheWay: "On The Way",
            Cancelled: "Cancelled",
            ViewAll: "View All",
            POS: "Call Center",
            ServicesTax: "Services & Taxes",
            BranchOrders: "Branch Orders",
            ProductData: "Product Data",
            ProductVariants: "Product Variants",
            ProductImages: "Product Images",
            Submit: "Submit",
            Uplaod: "Uplaod",
            NewProduct: "Add New Product",
            EditProduct: "Edit Product",
            EditImage: "Edit Image",
            Category: "Category",
            ChooseCategory: "Choose Category",
            ChooseSubcategory: "Choose Subcategory",
            ChooseBrand: "Choose Brand",
            FillForm: "kindly fill form and press save at the bottom",
            description: "description (optional)",
            bot5: "kindly log in or continue your order as a guest",
            bot6: "Our team will contact you after order is confirmed",
            AddressBook: "Choose an address from your address book",
            MyInfo: "Profile Information",
            Profile: "Profile",
            MyOrders: "Orders",
            MyAddressBook: "Address Book",
            NewOrder: "New Order",
            Update: "Update",
            Name: "Name",
            Phone: "Phone",
            Email: "Email",
            Password: "Password",
            PasswordMsg: "Leave Empty to keep current password",
            MyAddresses: "My Addresses",
            Cart: "Cart",
            Title: "Title",
            AddMore: "Add More",
            EmptyCart: "Empty Cart",
            CartEmpty: "Your cart is empty!",
            BrowseMenu: "Browse Menu",
            TitleAR: "Arabic Title",
            TitleEN: "English Title",
            Descriptions: "Product Descriptions",
            DescriptionAR: "Description in arabic",
            DescriptionEN: "Description in english",
            AdURL: "Ad URL",
            AdGroup: "Ad Group",
            Ads: "Ads",
            isAvilable: "is Available?",
            Current: "Current",
            ToCheckout: "To Checkout",
            Receipt: "Receipt",
            DeliveryInfo: "Delivery Information",
            OrderPrepared: "Your order is being prepared",
            Approval: "Done",
            invalidProvider: "Number can only starts with 010, 011, 012 or 015",
            invalidLength: "Phone number must be 11 digits",
            ChangeLang: "Change Language To",
            Hello: "Hello",
            LoginMsg: "Kindly login or continue as guest",
            SignMsg: "Welcome! Signup or coninue as a Guest",
            Signup: "Signup",
            QRMSG: "Save your order code to track it",
            Success: "Success!",
            Save: "Save",
            SaveAll: "Save All",
            Zones: "Zones",
            ZonesD: "Delivery Zones",
            NameAR: "Name (ar)",
            NameEN: "Name (en)",
            OrdersbyBranches: "Orders By Branch",
            Date: "Date",
            Status: "Status",
            Action: "Action",
            Pending: "Pending",
            Confirmed: "Confirmed",
            // Completed: "Completed",
            Cancelled: "Cancelled",
            Update: "Update",
            General: "General Details",
            Code: "Serial",
            CartPrice: "Cart Total",
            ProductQty: "Products Quantity",
            Notes: "Notes",
            NN: "No note available",
            Promocodes: "Promocodes",
            Edit: "Edit",
            StreetNameNum: "Street Name/Number",
            BuildingNum: "Bulding Number",
            FloorNum: "Floor Number",
            FlatNum: "Flat Number",
            Landmark: "Landmark",
            Code: "Code",
            Starts: "Starts",
            Ends: "Ends",
            Amount: "Amount",
            Type: "Type",
            Fixed: "Fixed",
            Precentage: "Precentage",
            CreatePromocode: "Create Promocode",
            editPromocode: "Edit Promocode",
            NewAccount: "Create New Account",
            Register: "Register",
            GuestOrders: "Orders as Guest",
            LatestDeals: "Latest Deals",
            Favorites: "Favorites",
            Uploaded: "Uploaded",
            Reset: "Reset",
            ImgSize: "Image size must not exceed 1 MB. Re-upload Please",
            LoginError: "Wrong phone number or password",
            Required: "This field is required",
            NameOOR: "The name must be at least 2 characters long",
            PhoneOOR: "The name must be 11 characters long",
            PhoneMS:
                "The phone must start with one of the following: 010, 011, 012, 015",
            PhoneUNQ:
                "This phone number has already been taken by another user",
            PhoneIV:
                "Phone number must be 11 (phone) or 7 - 8 digits (landline) digits long with code",
            PhoneIV2: "Phone number must be 9 digits long with code",
            PasswordOOR: "The password must be at least 6 characters",
            PasswordNS: "Password cannot contain spaces",
            Success: "Operation Successfull",
            AddCategory: "Add Category",
            AddProduct: "Add Product",
            ShowProducts: "Show Products",
            SetZone: "Set the closest delivery zone for the following orders",
            SetDZone: "Set Zone",
            Confirm: "Confirm",
            NAZ: "There are no orders without zones set",
            ChangeStatus: "Change Status",
            Change: "Change",
            BranchesStats: "Branches Statistics",
            Filter: "Filter",
            Clear: "Clear",
            SearchByCode: "Search By Order Code",
            SearchByUserCode: "Search By User Code",
            SuccessOrder: "Your order is being prepared",
            Optional: "Optional",
            SaveAsImg: "Save As Image",
            BrowseMenu: "Browse Menu",
            RedirectWarning:
                "Beware that you can't return this page after closing it",
            inputAddress: "Add Address",
            NAA: "No addresses to show add an address",
            ZoneP: "Zone",
            Search: "Search",
            SearchProducts: "Search Products",
            SearchByProductBarcode: "Search By Product Barcode",
            SearchResults: "Search Results",
            OrderNum: "Order Serial",
            Product: "Product",
            Image: "Image",
            Ingredients: "Choose your modifiers",
            AddIngredients: "Add Ingredients",
            Clients: "Clients",
            History: "History",
            Joined: "Joined at",
            NotesClient: "Notes on Client",
            Remove: "Remove",
            Extras: "Extras",
            GuestMsg: "Not a member?",
            OrderReceived: "New Order Receieved",
            Staff: "Staff",
            CreateStaff: "Add Employee",
            UserRemove: "Are you sure you want to remve this employee?",
            ProductNA: "Product Not Available",
            Description: "Description",
            NAExtras: "No extras Available",
            NDA: "Delivery Currently Unavailable",
            AddressToBook: "The new address will be added to your address book",
            NITM: "No",
            WithExtra: "extra",
            Affrim: "Are you sure?",
            InsertPhone: "Enter Phone Number",
            InsertPassword: "Enter Password",
            Continue: "Continue",
            OR: "Or",
            Grid: "Grid",
            List: "List",
            MyOrders: "My Orders",
            Notifications: "Notifications",
            CancelAddress: "Choose from my address",
            OrderSuccessNotification:
                "Order #{code} is being prepared. Another notification will be sent on status change.",
            CompleteMeal: "Complete Your Meal",
            Saving: "Saving...",
            MassUpload: "Mass Upload",
            UploadProducts: "Upload Products",
            UploadAll: "Upload All Products",
            DropFiles: "Drop files anywhere or click to upload",
            SelectFiles: "Select Files",
            UploadProduct: "Upload Product",
            AddProducts: "Add Multiple Products",
            isPrimary: "Main Category?",
            Deals: "Deals",
            NameRequired: "Name is required!",
            PhoneRequired: "Phone is required!",
            AddressRequired: "Choose or enter an address and a delivery zone",
            Category: "Category",
            VariantsError: "Kindly add at least one size to this product",
            TodaysOrders: "Today's Orders",
            From: "From Date",
            To: "To Date",
            OK: "Ok",
            OrderReceivedPlain:
                "Thank You!.. An order with the following code has been recieved",
            OrderReceived: "Thank You!.. Order #{0} has been recieved",
            OrderPending: "and is pending confirmation",
            OrderConfirmed:
                "Order #{0} has been confirmed and is being prepared.",
            OrderOnTheWay: "Order #{0} is on the way",
            OrderCompleted: "Order #{0} is delivered",
            ItemsQty: "Items Ordered",
            Move: "Move",
            MoveTo: "Move To",
            AddMore: "Add More",
            DeliveryMethod: "Order Type",
            Delivery: "Deliver My Meal",
            Pickup: "Take Away",
            PickupTime: "I will pickup my meal at",
            FromBranch: "From the following branch",
            ChooseBranch: "Choose Branch",
            BranchRequired: "Choose a branch to pick up from",
            SaveWAMessage: "Send Order Code as WhatsApp message",
            ScreenshootOrder:
                "Kindly screenshoot your order barcode and code to track your order or send it to restraunt",
            TakeawayTime: "Pickup Time",
            Settings: "Settings",
            GeneralSettings: "General Settings",
            RestrauntTitleAR: "Store Name (Arabic)",
            RestrauntTitleEN: "Store Name (English)",
            RestrauntPhone: "Store Phone",
            RestrauntWAPhone: "Whatsapp Number",
            Logo: "Logo",
            ImportantLinks: "Important Links",
            Website: "Website",
            Facebook: "Facebook",
            Twitter: "Twitter",
            Instagram: "Instagram",
            Youtube: "Youtube",
            WizardWelcome: "Hello! Let's setup your restaurant together",
            AdminProfile: "Admin Profile",
            HomeSlider: "Home Slider",
            ProuctSetup: "Prouct Setup",
            Sorry: "Sorry",
            Message404:
                "The restaurant is under construction, come back later please",
            WorkStarts: "from",
            WorkEnds: "to",
            WorkDay: "Work day starts",
            AdminName: "Restaurant Owner",
            AdminPhone: "Admin Phone",
            AdminPhoneMsg: "This number will be used to login to dashboard",
            SliderMsg:
                "Those images will be displayed in the home page. upload at least one image to continue",
            Upload: "Upload",
            BranchSetup: "Main Branch",
            MainBranchDetails:
                "You must have at least one branch and one delivery zone on your restraunt> Kindly fill your restaurant's main branch information below",
            AddZone: "Add Delivery Zone",
            submitBranch: "Add Branch and Delivery Zones",
            RestaurantSetup: "Congratulations!",
            RestaurantSetupMsg:
                "Your restaurant management is setup, Login to add your categories and products",
            AddProducts:
                "Kindly add at least one category and one product in that category to start accepting orders",
            RestrauntTitle: "Restraunt Title",
            MaxImages: "Maximum images for the slider is 12 images",
            SliderImages: "Slider Images",
            DragImages: "Drop images here to upload",
            SliderOverLimit:
                "You have exceeded the number of allow slider photos only ",
            Allowed: " Of your uploaded images will be added",
            Optional: "Optional",
            BranchLocationURL: "Branch Google Maps Link",
            ExtraNotes: "Extra Notes",
            RepeatOrder: "Repeat Order",
            RepeatedOrder:
                "Would you like to order the same order with the same products again?",
            checkOrder: "Track Your Orders",
            GetStatus: "Track My Order",
            GetStatusTxt:
                "You seem to be not registered! would you like to register to view all your orderds? Or continue as a guest",
            AddAddress: "Add Address",
            EditAddress: "Edit Address",
            OrderSettings: "Orders Settings",
            AddStatus: "Add new order status",
            StatusColor: "Status Color",
            DiscountPrice: "Discount Price",
            DiscountType: "Discount Type",
            DiscountAmount: "Discount Amount",
            DiscountOptions: "add the discount to product options",
            Dishes: "Products",
            Prices: "Product Prices",
            PhoneNumber: "Phone Number",
            OrderCode: "Order Code",
            Appearance: "Appearance",
            Background: "Background Color",
            BackgroundColor: "Background Color",
            PrimaryColor: "Primary Color",
            SecondaryColor: "Secondary Color",
            BorderRadius: "Border Radius",
            CardBorderRadius: "Card Border Radius",
            SliderHeight: "Slider Height",
            DiscountImageAR: "Discount Image (AR)",
            DiscountImageEN: "Discount Image (EN)",
            PX: "Pixel (px)",
            UserNotFound: "No users or orders found with this number",
            PasswordReset: "Kindly reset your password",
            NewPasword: "New Pasword",
            ResetSuccess: "Password reset successful! Login with new password",
            UploadUsers: "Upload Users",
            Invited: "Invited",
            Verified: "Verified",
            SecurePassword: "Secure Password",
            VerifyUser: "Verify User",
            MassBranches: "Upload from Excel",
            RefreshedPage: "Page Refreshed",
            InvitedClients: "Invited Clients",
            Invite: "Invite URL",
            ShowMenu: "Order Now",
            Landing: "Home",
            LandingPage: "Customize Landing Page",
            NewAd: "New Ad",
            NewAdGroup: "New Ad Group",
            VisitAd: "More",
            PackageItems: "Package Items",
            Show: "Show?",
            HomeBackground: "Landing Page Background Image",
            AdsBackgroundColor: "Ads Background Color",
            CardBackground: "Card Background Color",
            GridOptions: "Grid Options",
            GridColumnsIn: "Grid Columns In",
            MobileScreen: "Mobile Screen",
            TabletScreen: "Tablet Screen",
            BigScreen: "Larger Screens",
            GridGap: "Grid Gap",
            ImageBR: "Section Border Radius",
            AdBR: "Ad  Border Radius",
            AdModalIH: "Ad Modal Image Height",
            AdModalIV: "Ad Modal Image Width",
            TextColor: "Text Color",
            TitleDetails: "Title Details",
            ZoneUnavailable:
                "This zone is unavailable kindly edit the address and change it",
            EditDeliveryMethod: "Edit Delivery Method",
            CustomerData: "Customer Information",
            NotAdded: "Not Specified",
            ContainerWidth: "Image Container Width",
            Height: "Height",
            ContentWidth: "Content Width",
            ContentType: "Content Type",
            TypeNotes: "type your notes...",
            RestrauntDeliveryTime: "Delivery Time (minutes)",
            Select: "Select",
            StockEnabled: "Enable Stock Tracking?",
            Stock: "Stock",
            LowStockAlert: "Low Stock Alert",
            Restock: "Restock",
            Available: "Available",
            Recommended: "Recommended",
            Icon: "Icon",
            SlideShow: "Slide Show",
            CategoryListView: "Category List View",
            CategoryGridView: "Category Grid View",
            AdWidget: "Ad Widget",
            LayoutContainer: "Layout Container",
            GridType: "Grid Shape",
            NumberOfSections: "Number Of Sections",
            SectionsSpacing: "Sections Spacing",
            LayoutSections: "Layout Sections",
            VerticalSpacing: "Spacing above and below group",
            ProductHasOptions: "Product has options",
            PriceSettings: "Price Settings",
            OutOfStock: "Product out of stock",
            AddedToCart: "Product Added To Cart",
            Sort: "Sort By",
            NoSort: "None",
            PriceASC: "Price Low to High",
            PriceDSC: "Price High to Low",
            FromP: "From",
            ToP: "To",
            PriceFilter: "Filter By Price",
            SearchResult: "Search Results",
            PickProducts: "Category Products",
            isAdvertisment: "Adverisement Category",
            ProductSlider: "Product Slider",
            ChooseOrUpload: "Choose or upload image",
            URLAR: "URL Text (AR)",
            URLEN: "URLText (EN)",
            CustomizeApp: "Customize App",
            ShowTitle: "Show Title",
            ShowLink: "Show Link",
            PickWidget: "Pick Widget",
            ChooseImages: "Choose Images",
            Customize: "Customize",
            ChooseProduct: "Choose Product",
            Tags: "Tags",
            DisplayedTags: "Displayed Tags",
            Social: "Social Links",
            PaymentMethod: "Payment Method",
            cash: "Cash On Delivery",
            card: "Debit / Credit Card",
            FB: "Facebook Link",
            TW: "Twitter Link",
            IG: "Instagram Link",
            YT: "Youtube Link",
            WA: "phone number without country code or 0 at start (e.g. 201234567890)",
            TextWidget: "Text Widget",
            InStock: "In Stock",
            VerifyProducts: "Verify Products",
            SimilarProducts: "Similar Products",
            AddedToProduct: "Add To Product",
            LeftInStock: "left in stock",
            Hide: "Hide",
            HideSelected: "Hide Selected",
            ReasonToHide: "Reason to hide",
            Barcode: "Barcode",
            ShowHidden: "Show Hidden",
            ShowVisible: "Show Visible",
            Choose: "Choose",
            MenuLimit: "Menu Links Limit",
            ContainerHeight: "Container Height",
            IsTransparent: "is transparent?",
            ShadowEnabled: "Drop Shadow",
            ImageShadowEnabled: "Image Box Shadow",
            SlidesPerView: "Slides Per View",
            SpaceBetweenSlides: "Space Between Slides",
            RelatedProducts: "Related Products",
            Brands: "Brands",
            Brand: "Brand",
            AddBrand: "Add Brand",
            MyHome: "Home",
            MyCart: "Shopping Cart",
            MyProfile: "My Profile",
            BrowseCategories: "Browse Categories",
            BrowseBrands: "Browse By Year",
            Header: "Header",
            Section1: "Section 1",
            Section2: "Section 2",
            Section3: "Section 3",
            Section4: "Section 4",
            Preveiw: "Preveiw",
            CardHeight: "Card Height",
            ImageHeight: "Image Height",
            ImgBorderRadius: "Image Border Radius",
            ItemsLimit: "No. Items to Show",
            ShowCategoryTitle: "Show Category Title",
            ShowProductInfo: "Show Product Title & Price",
            ProductTitle: "Product Title",
            ProductPrice: "Product Price",
            HideBackground: "Hide Background Color",
            ImageBorder: "Image Border",
            PaymentStatus: "Payment Status",
            Paid: "Paid",
            Unpaid: "Unpaid",
            PaymentInfo: "Payment Information",
            InvoiceURL: "Invoice URL",
            PaymentURL: "Payment URL",
            Press2Pay: "Tab Here",
            PaymentElectronic: "enable e-payment",
            PaymentCash: "enable cash on delivery",
            NoPaymentFound: "ُEnable at least one payment method",
            NoDeliveryFound: "Enable at least one delivery method",
            FinalPrice: "Subtotal",
            PaymentPermission:
                "Grant us permission to redirect you to payment page",
            MustRegister: "You must register new user first to continue",
            ClientNotes: "Client Notes",
            NumOfOrders: "Number of Orders",
            AppendOrder:
                "Would you like to append current order to previous order?",
            AddPhone: "Add Phone",
            SaveUser: "Save New Customer",
            GUser: "User not registered",
            AddPhoneMessage: "Add phone numbers to user's phone book",
            UpdateUser: "Update User",
            AddressManual: "Input Address",
            ClientOrders: "Client Orders",
            OrderCount: "Order Count",
            CancelledCount: "Cancelled Orders Count",
            FirstOrder: "First Order Date",
            LastOrder: "Last Order Date",
            OrderAvg: "Order Average",
            AddNote: "Add Note...",
            Send: "Send",
            WidgetAdded: "New widget added!",
            EnableCallcenter: "Enable Call Center",
            EnableProductSupervision: "Enable Product Supervision",
            Variants: "Product Variants",
            Variant: "Product Variant",
            Values: "Variant Value",
            NewVariant: "Add New Variant",
            NewVariantValue: "Add New Variant Value",
            NoVariants:
                "No product variants available, kindly add product variants then proceed",
            AllowBarcodeEdit: "All barcode editing in product update",
            ShowBarcode: "Show barcode field in product create",
            AvailableQty: "Available Quantity",
            DeliveredBy: "Delivered By",
            ParentOrder: "Parent Order",
            ChildOrder: "Appended Order",
            NeutralOrder: "Regular Order",
            AppendOrders: "Append Orders",
            AppendedTo: "Parent Order",
            Navigation: "Navigation",
            Role: "Role",
            Employee: "Employee",
            Admin: "Admin",
            Operator: "Operator",
            CallCenter: "Call Center",
            CallCenterManager: "Call Center Manager",
            HasMobileApp: "Store has a mobile application",
            AppleStore: "Apple Store (App Store) URL",
            PlayStore: "Play Store URL",
            Offers: "Offers",
            CreateOffer: "Create New Offer",
            Advertisers: "Advertisers",
            CreateAdvertiser: "Create New Advertiser",
            OfferTypes: "Offer Types",
            CreateOfferType: "Create New Offer Types",
            Promocode: "Promocode",
            PromocodeSearch: "Search By Promocode",
            Advertiser: "Advertiser",
            OfferType: "OfferType",
            IsActive: "is Active ?",
            DeductFixed: "Deduct Amount",
            DeductPercent: "Deduct Percent %",
            FixedPrice: "Fixed Price",
            Active: "Active",
            InActive: "Not Active",
            UnableToRemove: "Unable to removed due data dependant on it",
            ProductInOtherOffer:
                "Warning! this product exists in another offer",
            isPromotional: "is Promotional?",
            CategoryType: "Category Type",
            Visible: "Visible",
            Invisible: "Hidden",
            Main: "Main Category",
            Promotional: "Promotional Category",
            AttachProducts: "Attach Products",
            AddDescription: "Add description to options",
            VariantImages: "Color Images",
            VariantColor: "Color",
            Saved: "Saved",
        },
    },
});
